import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import { criarCadastroModelos } from "../../DataSources";
import ShowError from "../../AppServices";
import api from "../../api-axios";

const template = {
  id: undefined,
  prefeituraId: undefined,
  nome: "",
  titulo: "",
  tipoValidacao: "",
  qtdeCampos: 1,
  legendaCampo1: "",
  instrucaoCampo1: "",
  legendaCampo2: "",
  instrucaoCampo2: "",
  legendaCampo3: "",
  instrucaoCampo3: "",
};

export default class CadastroModelosForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { fieldsAmount: 1, validationTypes: [] };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.criarCadastroModelos = criarCadastroModelos();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.fieldsAmountOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [1, 2, 3],
      onValueChanged: (e) => this.setState({ fieldsAmount: e.value }),
    };
  }

  componentDidMount() {
    api
      .get("validacao_documentos/buscar_nomes_algoritmos")
      .then((response) => {
        if (response.data) {
          this.setState({ validationTypes: response.data });
        }
      })
      .catch((error) => {
        if (error.response) {
          ShowError(error.response.data);
          notify(error, "error", 2000);
        }
      });

    if (this.props.match.params.id !== undefined) {
      this.criarCadastroModelos
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (!data) {
            notify("Modelo não encontrado.", "error");
            this.props.history.push("/cadastro-modelos");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    const validationTypesOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: this.state.validationTypes,
    };

    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={this.state} colCount={2} labelLocation="top">
          <GroupItem caption="Cadastro de Modelos" colSpan={2} colCount={3}>
            <SimpleItem dataField={"nome"} colSpan={2}>
              <Label text="Nome" />
            </SimpleItem>
            <SimpleItem dataField={"titulo"}>
              <Label text="Título" />
            </SimpleItem>
            <SimpleItem
              dataField={"tipoValidacao"}
              editorType={"dxLookup"}
              editorOptions={validationTypesOptions}
            >
              <Label text="Tipo de Validação" />
            </SimpleItem>
            <SimpleItem
              dataField={"qtdeCampos"}
              editorType={"dxLookup"}
              editorOptions={this.fieldsAmountOptions}
            >
              <Label text="Quantidade de Campos" />
            </SimpleItem>
            <EmptyItem colSpan={1} />
            <SimpleItem dataField={"legendaCampo1"}>
              <Label text="Legenda do Campo 1" />
            </SimpleItem>
            <SimpleItem dataField={"instrucaoCampo1"} colSpan={2}>
              <Label text="Instrução do Campo 1" />
            </SimpleItem>
            <SimpleItem
              dataField={"legendaCampo2"}
              visible={this.state.fieldsAmount >= 2}
            >
              <Label text="Legenda do Campo 2" />
            </SimpleItem>
            <SimpleItem
              dataField={"instrucaoCampo2"}
              visible={this.state.fieldsAmount >= 2}
              colSpan={2}
            >
              <Label text="Instrução do Campo 2" />
            </SimpleItem>
            <SimpleItem
              dataField={"legendaCampo3"}
              visible={this.state.fieldsAmount === 3}
            >
              <Label text="Legenda do Campo 3" />
            </SimpleItem>
            <SimpleItem
              dataField={"instrucaoCampo3"}
              visible={this.state.fieldsAmount === 3}
              colSpan={2}
            >
              <Label text="Instrução do Campo 3" />
            </SimpleItem>
          </GroupItem>
        </Form>
        <Form>
          <GroupItem colCount={6}>
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "success",
                text: "Salvar",
                onClick: this.ok,
              }}
            />
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "warn",
                text: "Cancelar",
                onClick: this.cancel,
              }}
            />
          </GroupItem>
        </Form>
      </div>
    );
  }

  async ok() {
    try {
      const entidade = this.state;
      const modelId = this.props.match.params.id;
      const requestType = modelId !== undefined ? "PUT" : "POST";
      let response = {};
      console.log("entidade: ", entidade);
      if (requestType === "POST") {
        response = await api.post(
          "validacao_documentos/adicionar_modelo",
          entidade
        );
      } else {
        response = await api.put(
          `validacao_documentos/editar_modelo/${modelId}`,
          entidade
        );
      }

      if (response && response.status === 200) {
        notify("Modelo cadastrado com sucesso.", "success");
        //this.props.history.goBack();
      }
    } catch (error) {
      if (error.response) {
        ShowError(error.response.data);
      }
      notify(error, "error", 2000);
    }
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
